
import React, { memo } from 'react';
import { EditorTabs } from './editors/EditorTabs';
import { EditorTips } from './EditorTips';
import { StableEditorContainer } from './StableEditorContainer';

interface HtmlEditorProps {
  htmlContent: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement> | string) => void;
  previewHtml: string;
  getPreviewHtmlWithExampleValues: (html: string) => string;
}

export const HtmlEditor = memo(function HtmlEditor({ 
  htmlContent, 
  onChange, 
  previewHtml, 
  getPreviewHtmlWithExampleValues 
}: HtmlEditorProps) {
  return (
    <div 
      className="bg-white border rounded-md overflow-visible flex flex-col"
      style={{
        minHeight: '600px',
        width: '100%',
        contain: 'style',
        isolation: 'isolate',
        transition: 'opacity 0.2s ease-in-out',
      }}
    >
      <StableEditorContainer height="600px">
        <EditorTabs
          htmlContent={htmlContent}
          onChange={onChange}
          previewHtml={previewHtml}
          getPreviewHtmlWithExampleValues={getPreviewHtmlWithExampleValues}
        />
      </StableEditorContainer>
      
      <EditorTips />
    </div>
  );
});

HtmlEditor.displayName = 'HtmlEditor';

